import React from 'react';
import Icon from '../../../components/AppIcon';

const PerformanceMetricCard = ({ 
  title, 
  value, 
  unit = '', 
  trend, 
  trendValue, 
  benchmark, 
  icon, 
  color = 'primary' 
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-success';
    if (trend === 'down') return 'text-error';
    return 'text-muted-foreground';
  };

  const getColorClasses = () => {
    const colors = {
      primary: 'from-primary to-secondary',
      success: 'from-success to-emerald-400',
      warning: 'from-warning to-amber-400',
      error: 'from-error to-red-400',
      secondary: 'from-secondary to-primary'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="group relative bg-white border border-slate-200/60 rounded-2xl p-24 shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden">
      <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br opacity-5 group-hover:opacity-10 transition-opacity rounded-bl-full" 
           style={{ backgroundImage: `linear-gradient(to bottom right, var(--color-${color}), transparent)` }}></div>
      
      <div className="relative">
        <div className="flex items-start justify-between mb-16">
          <div className="flex-1 min-w-0">
            <p className="text-sm text-slate-600 font-medium mb-8">{title}</p>
            <div className="flex items-baseline gap-8">
              <h3 className="text-4xl font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
                {value}
              </h3>
              {unit && (
                <span className="text-base text-slate-500 font-medium">{unit}</span>
              )}
            </div>
          </div>
          <div className={`w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0 bg-gradient-to-br ${getColorClasses()} shadow-lg`}>
            <Icon name={icon} size={24} className="text-white" />
          </div>
        </div>

        <div className="flex items-center justify-between gap-12 pt-16 border-t border-slate-100">
          <div className={`flex items-center gap-8 px-12 py-6 rounded-lg ${getTrendColor()} bg-current/10`}>
            <Icon name={getTrendIcon()} size={16} className={getTrendColor()} />
            <span className={`text-sm font-bold ${getTrendColor()}`}>
              {trendValue}
            </span>
          </div>
          {benchmark && (
            <span className="text-xs text-slate-500 font-medium">
              Target: {benchmark}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PerformanceMetricCard;